import { useState, useEffect } from "react";
import { formattedCameraTemplate, hasCameraTemplate } from '../../utilities/cameraTemplateUtilities';
import { cameraLogos } from "../../utilities/cameraLogos";
import Api from '../api/api';

const staticIpUrlBase = "http://51.140.225.181";

export const webhooksContent = [
    {
        title: "Unknown",
        webhookUrl: null,
    },
    {
        title: "Mav",
        webhookUrl: "mav",
    },
    {
        title: "Mobotix",
        webhookUrl: "mobotix",
    },
    {
        title: "hikvision",
        webhookUrl: "hikvision",
        showStaticIpUrl: true,
    },
    {
        title: "vreo",
        webhookUrl: "vreo",
    },
    {
        title: "DTK",
        webhookUrl: "dtk",
    },
    {
        title: "Milesight",
        webhookUrl: "milesight",
    },
    {
        title: "Plate Recognizer",
        webhookUrl: "plate-recognizer",
    },
    {
        title: "Arvoo",
        webhookUrl: "arvoo",
    },
    {
        title: "Reolink",
        webhookUrl: null,
        ftpDetails: {
            host: "ftp.advancedparking.tech",
            port: "21",
            directory: "",
            username: "",
            password: "",
        },
    },
]

export const Webhooks = (props) => {

    const webHookBaseUrl = `https://api.advancedparking.tech/${props.organisationId}/webhooks/`;

    const [cameraTemplateModalContent, setCameraTemplateModalContent] = useState(null);
    const [copyResultMessage, setCopyResultMessage] = useState(null);
    const [ftpUsername, setFtpUsername] = useState("");
    const [ftpPassword, setFtpPassword] = useState("");

    useEffect(() => {
        Api.getOrganisationSettings(
            (data) => {
                setFtpUsername(data.ftpUsername);
                setFtpPassword(data.ftpPassword);
            },
            (error) => console.log(error),
            props.organisationId,
            props.token
        );
    }, [props.organisationId, props.token]);

    const content = webhooksContent.map((item) => item.title === "Reolink" ? {
        ...item,
        ftpDetails: {
            ...item.ftpDetails,
            directory: props.macAddress || "",
            username: ftpUsername || "",
            password: ftpPassword || "",
        },
    } : item);

    const handleCameraTemplateCopy = (data) => {
        navigator.clipboard.writeText(data)
            .then(() => {
                setCopyResultMessage("Successfully copied!");
            })
            .catch(() => {
                setCopyResultMessage("Unable to copy, please try again!");
            })

            setTimeout(() => {
                setCopyResultMessage(null);
            }, 2000)
    }

    return (
        <div className="card mb-3">
            {
                cameraTemplateModalContent && (
                    <div className="modal fade" id="templateModal" tabIndex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{cameraTemplateModalContent.title}</h5>
                                    <button
                                        onClick={() => setCopyResultMessage(null)}
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="p-4">
                                    <pre>
                                        { cameraTemplateModalContent.formattedJson }
                                    </pre>
                                </div>
                                <div className="modal-footer">
                                    {
                                        copyResultMessage && <p className="fs-1">{copyResultMessage}</p>
                                    }
                                    <button
                                        type="button"
                                        className="btn ml-2 d-flex align-items-center gap-3"
                                        onClick={() => handleCameraTemplateCopy(cameraTemplateModalContent.formattedJson)}
                                    >
                                        <i className="fas fa-copy mr-2"></i>
                                        Copy
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            <div className="card-header">
                <div className="row align-items-center">
                    <div className="col">
                        <h5 className="mb-0">Webhook URLs</h5>
                    </div>
                </div>
            </div>
            <div className="card-body bg-light border-top">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Camera Type</th>
                                <th scope="col">Webhook URL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                content.map((item, index) => (
                                    index !== 0 &&
                                    <tr key={item.title}>
                                        <th scope="row">
                                            <img src={cameraLogos[index].imageUrl} alt={cameraLogos[index].title} style={{ maxHeight: "25px" }} />
                                        </th>
                                        <td>
                                            {
                                                item.ftpDetails ? (
                                                    <div className="d-flex flex-column gap-1">
                                                        {
                                                            Object.entries(item.ftpDetails).map(([label, value]) => (
                                                                <div key={label} className="d-flex align-items-center">
                                                                    <span className="text-capitalize mr-2" style={{ minWidth: "80px" }}>{label}:</span>
                                                                    <span>{value || "—"}</span>
                                                                    <button
                                                                        className='btn'
                                                                        onClick={() => navigator.clipboard.writeText(value || "")}
                                                                    >
                                                                        <div>
                                                                            <i className="fas fa-copy" />
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                ) : (
                                                    <>
                                                        {webHookBaseUrl}{item.webhookUrl}
                                                        <button
                                                            className='btn'
                                                            onClick={() => navigator.clipboard.writeText(`${webHookBaseUrl}${item.webhookUrl}`)}
                                                        >
                                                            <div>
                                                                <i className="fas fa-copy" />
                                                            </div>
                                                        </button>
                                                        {
                                                            hasCameraTemplate(item.webhookUrl) && (
                                                                <button
                                                                    data-toggle="modal"
                                                                    data-target="#templateModal"
                                                                    className='btn'
                                                                    onClick={() => setCameraTemplateModalContent({
                                                                        title: `${item.title} Message Template`,
                                                                        formattedJson: formattedCameraTemplate(item.webhookUrl)
                                                                    })}
                                                                >
                                                                    <i className="far fa-file-code" />
                                                                </button>
                                                            )
                                                        }
                                                        {
                                                            item.showStaticIpUrl && (
                                                                <>
                                                                    <br />
                                                                    <strong>OR</strong>
                                                                    <br />
                                                                    {`${staticIpUrlBase}/${props.organisationId}/webhooks/${item.webhookUrl}`}
                                                                    <button
                                                                        className='btn'
                                                                        onClick={() => navigator.clipboard.writeText(`${staticIpUrlBase}/${props.organisationId}/webhooks/${item.webhookUrl}`)}
                                                                    >
                                                                        <i className="fas fa-copy" />
                                                                    </button>
                                                                </>
                                                            )
                                                        }
                                                    </>
                                                )
                                            }
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )
}

